import { render, staticRenderFns } from "./CustomChangePassword.vue?vue&type=template&id=37d6c238"
import script from "./CustomChangePassword.vue?vue&type=script&lang=js"
export * from "./CustomChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports